<template>
    <div>
        <b-row class="justify-content-lg-center">
            <b-col
                cols="12"
                lg="9"
            >
                <p class="h4 color-mid-grey text-bold text-center mb-5">
                    Please set the viewing availailbity for this property below
                </p>
            </b-col>
        </b-row>

        <table class="availability mb-5">
            <thead>
                <tr>
                    <td style="background: #f9f9f9;" />
                    <th
                        v-for="day in days"
                        :key="day.id"
                        scope="col"
                    >
                        {{ day.name }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="slot in slots"
                    :key="slot"
                >
                    <th scope="row">
                        {{ slot }}
                    </th>
                    <td
                        v-for="day in days"
                        :key="day.id"
                        :class="{ selected : checkForSlot(day.id, slot) !== -1 }"
                        class="time-slot"
                        @click="toggleSlot(day.id, slot)"
                    >
                        <SVGSprite
                            v-if="checkForSlot(day.id, slot) !== -1"
                            class="check-icon"
                            name="checked"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'EditAvailability',
    props: {
        property: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            days: [
                {
                    id: 1,
                    name: 'Mon'
                },
                {
                    id: 2,
                    name: 'Tue'
                },
                {
                    id: 3,
                    name: 'Wed'
                },
                {
                    id: 4,
                    name: 'Thur'
                },
                {
                    id: 5,
                    name: 'Fri'
                },
                {
                    id: 6,
                    name: 'Sat'
                },
                {
                    id: 0,
                    name: 'Sun'
                }
            ],
            slots: [
                '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00',
                '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30',
                '18:00', '18:30', '19:00', '19:30', '20:00', '20:30'
            ],
            selected: []
        };
    },
    mounted() {
        this.selected = [...this.property.availabilities];
    },
    methods: {
        ...mapActions('properties', ['createViewingRequest']),
        toggleSlot(day, time) {
            const slot = this.checkForSlot(day, time);
            if (slot === -1) {
                this.selected.push({ day, start_at: time });
            }
            else {
                this.selected.splice(slot, 1);
            }
            this.$emit('updated', this.selected);
        },
        checkForSlot(day, time) {
            return this.selected.findIndex(slot => slot.day === day && slot.start_at === time);
        }
    }
};
</script>

<style lang="scss">
// availability
.availability {
    table-layout: fixed;
    width: 100%;
    border: 1px solid #f3f3f3;
    border-radius: global-var('rounded-corners');

    th, td {
        border: 1px solid #f3f3f3;
        padding: 2px 4px;
    }

    th {
        background: #f9f9f9;

        &[scope=col] {
            text-align: center;
        }
    }

    tbody {
        td {
            position: relative;
            background: #d2d2d2;
            cursor: pointer;
            vertical-align: middle;
            text-align: center;

            &.unbookable {
                background: #d2d2d2 !important;
                pointer-events: none !important;
            }

            &.selected {
                background: theme-color('secondary');
            }

            .check-icon {
                width: 16px;
                height: 16px;
                color: white;
            }
        }
    }
}
</style>
